<template>
  <div class="h-full flex">
    <div class="h-full w-300px flex-shrink-0">
      <el-card class="h-full">
        <div class="mb-10px flex items-center text-14px">
          <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">评价项目</span>
          <el-dropdown>
            <span class="el-dropdown-link">
              <i class="iconfont icon-line-moreVertical text-14px font-bold"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
              <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="flex mb-10px">
          <el-input
            size="small"
            placeholder="关键字"
            prefix-icon="el-icon-search"
            v-model="treeKeyword"
            class="mr-10px flex-1"
            clearable
            @keyup.enter.native="searchTreeData"
          ></el-input>
          <el-button type="primary" class="!h-36px" size="mini" @click="searchTreeData"
            >搜索</el-button
          >
          <el-button
            type="primary"
            class="!h-36px"
            size="mini"
            @click="handleTreeData('', 'createProjectConfig')"
            >新增</el-button
          >
        </div>
        <div class="tree overflow-y-auto">
          <el-tree
            v-if="treeStandBy"
            :default-expand-all="defaultExpandAll"
            v-loading="treeLoading"
            highlight-current
            :data="treeData"
            @node-click="handleDocNodeClick"
            :filter-node-method="filterTreeNode"
            :expand-on-click-node="false"
            :props="defaultTreeProps"
            node-key="id"
            ref="tree"
            :default-expanded-keys="defaultExpandIds"
            @node-expand="nodeExpand"
            @node-collapse="nodeCollapse"
          >
            <div slot-scope="{ node, data }" class="node-item">
              <div class="custom-tree-node">
                <p :title="node.label" class="flex-1 mr-15px truncate">
                  {{ data.chapter }} {{ node.label }}
                </p>
                <!-- <p :title="node.displayName" class="flex-1 mr-15px truncate">
                    {{ node.displayName }}
                  </p> -->
                <div class="mr-5px">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <i class="iconfont icon-line-moreVertical text-14px font-bold"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="handleTreeData($event, 'createChild', data)"
                        >新增</el-dropdown-item
                      >
                      <el-dropdown-item
                        @click.native="
                          handleTreeData($event, data.parentId ? 'editChild' : 'edit', data)
                        "
                        :disabled="data.safetyEvaluationId !== null"
                        >编辑</el-dropdown-item
                      >
                      <el-dropdown-item
                        @click.native="
                          removeTreeData(
                            $event,
                            data.parentId ? 'deleteChild' : 'delete',
                            data,
                            data
                          )
                        "
                        >删除</el-dropdown-item
                      >
                      <el-dropdown-item
                        :disabled="data.parentId !== null"
                        @click.native="handleTreeData($event, 'copy', data)"
                        >复制</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </el-tree>
        </div>
      </el-card>
    </div>
    <div class="h-full rightCol flex-auto w-0px ml-10px">
      <el-card class="h-full">
        <div class="mb-10px flex items-center text-14px">
          <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">评价详情列表</span>
        </div>
        <div class="w-full h-full">
          <div class="flex mb-20px mr-10px">
            <el-input
              size="small"
              class="mr-10px !w-50"
              placeholder="评价项目"
              maxlength="50"
              v-model="projectSearchData.project"
              clearable
            ></el-input>
            <el-button size="small" type="primary" @click="handleSearch()">搜索</el-button>
            <el-button size="small" @click="resetText()">重置</el-button>
            <el-button
              size="small"
              type="primary"
              @click="handleEvent(null, 'create')"
              :disabled="!$hasAccess('create')"
              >新增</el-button
            >
          </div>
          <el-table
            :data="projectDataList"
            border
            class="w-full"
            :height="tableHeight"
            stripe
            v-loading="projectTableLoading"
            @selection-change="handleSelectionProject"
          >
            <el-table-column label="序号" prop="chapter" width="150"></el-table-column>
            <el-table-column label="评价项目" prop="project" width="150"></el-table-column>
            <el-table-column label="评价内容" prop="content" width="450"></el-table-column>
            <el-table-column
              label="评价分(10)分"
              prop="standardScore"
              width="150"
            ></el-table-column>
            <el-table-column label="评价标准" prop="scoringStandar" width="450"></el-table-column>
            <el-table-column label="操作" width="180" fixed="right">
              <template slot-scope="scope">
                <table-operate-button :key="scope.row.id" :buttons="buttonsProject(scope.row)" />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>
    <!-- 新增 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="addFirstProjectConfigFormTitle"
      :visible.sync="addFirstProjectConfigFormVisible"
      v-if="addFirstProjectConfigFormVisible"
      width="718px"
      class="small-dialog"
      v-dialogDrag
    >
      <el-form
        :model="addFirstProjectConfigForm"
        :rules="addFirstProjectConfigFormRules"
        ref="addFirstProjectConfigRef"
        label-width="150px"
      >
        <el-form-item label="新增目录序号" prop="chapter">
          <el-input-number
            size="small"
            v-model="addFirstProjectConfigForm.chapter"
            :controls="false"
            class="w-full"
            :precision="0"
            placeholder="请输入目录序号"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="新增目录名称" prop="name">
          <el-input
            placeholder="请输入"
            v-model="addFirstProjectConfigForm.name"
            size="small"
            class="!w-full"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button
          size="small"
          type="primary"
          icon="iconfont icon-save"
          @click="saveFirstProjectConfigForm"
          >保存</el-button
        >
        <el-button size="small" icon="iconfont icon-close" @click="cancelFirstProjectConfigForm"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <!-- 新增子目录 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="addSubProjectConfigFormTitle"
      :visible.sync="addSubProjectConfigFormVisible"
      v-if="addSubProjectConfigFormVisible"
      class="small-dialog"
      v-dialogDrag
    >
      <el-form
        :model="addSubProjectConfigForm"
        :rules="addSubProjectConfigFormRules"
        ref="addSubProjectConfigRef"
        label-width="150px"
      >
        <el-form-item label="所属上级目录" prop="upName">
          <el-input
            placeholder="请输入"
            disabled
            v-model="addSubProjectConfigForm.upName"
            size="small"
            class="!w-full"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="新增评价序号" prop="chapter" class="two-row">
          {{ addSubProjectConfigForm.upChapter }}.
          <el-input-number
            size="small"
            v-model="addSubProjectConfigForm.chapter"
            :controls="false"
            class="w-full"
            :precision="0"
            placeholder="请输入新增评价序号"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="新增评价目录" prop="name">
          <el-input
            placeholder="请输入"
            v-model="addSubProjectConfigForm.name"
            size="small"
            class="!w-full"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="是否涵盖评价内容" prop="isContainsEvaluation">
          <el-radio-group v-model="addSubProjectConfigForm.isContainsEvaluation">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button
          size="small"
          type="primary"
          icon="iconfont icon-save"
          @click="saveSubProjectConfigForm"
          >保存</el-button
        >
        <el-button size="small" icon="iconfont icon-close" @click="cancelSubProjectConfigForm"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <AddEvaluationProject
      v-model="addEvaluationProjectVisible"
      :treeData="treeData"
      :currentTreeSelect="currentTreeSelect"
    />
    <el-dialog
      :close-on-click-modal="false"
      title="复制"
      :visible.sync="copyProjectConfigFormVisible"
      width="718px"
      class="small-dialog"
      v-dialogDrag
    >
      <el-form :model="copyProjectConfigForm" ref="copyProjectConfigFormRef" label-width="150px">
        <el-form-item
          label="目录名称"
          prop="name"
          :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
        >
          <el-input
            placeholder="请输入"
            v-model="copyProjectConfigForm.name"
            size="small"
            class="!w-full"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button
          size="small"
          type="primary"
          icon="iconfont icon-save"
          @click="saveCopyProjectConfigForm"
          >保存</el-button
        >
        <el-button size="small" icon="iconfont icon-close" @click="cancelCopyProjectConfigForm"
          >取消</el-button
        >
      </div>
    </el-dialog>

    <!-- 关联模块 start -->
    <RelationModule
      v-if="showRelationModuleDialog"
      :visible.sync="showRelationModuleDialog"
      :operateData="relationModuleRow"
      @refreshList="handleSearch"
    ></RelationModule>
    <!-- 关联模块 end -->
  </div>
</template>

<script>
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import utils from '@/components/safety/enumField/utils'
import { SafetyEvaluationIndexApi } from '@wiz-api/safety-evaluation-management'
import AddEvaluationProject from '../components/AddEvaluationProject'
import RelationModule from '../components/RelationModule'

const safetyEvaluationIndexApi = new SafetyEvaluationIndexApi()
export default {
  components: {
    TableOperateButton,
    AddEvaluationProject,
    RelationModule,
  },
  data() {
    return {
      copyProjectConfigFormVisible: false,
      copyProjectConfigForm: {
        name: '',
      },
      addSubProjectConfigFormTitle: '新增子目录',
      addFirstProjectConfigFormTitle: '新增目录',
      addSubProjectConfigForm: {
        isContainsEvaluation: true,
      },
      addSubProjectConfigFormRules: {
        chapter: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur',
          },
        ],
      },
      addSubProjectConfigFormVisible: false,
      addEvaluationProjectVisible: false,
      uploadLoading: false,
      questionSourceId: '',
      createType: 'createQuestion',
      showTree: true,
      addFirstProjectConfigForm: {
        index: 1,
        name: '',
      },
      treeStandBy: true, // 是否显目录树 用于刷新树
      addFirstProjectConfigFormRules: {
        chapter: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur',
          },
        ],
      },
      currentTreeSelect: {},
      addFirstProjectConfigFormVisible: false, // addFirstProjectConfigFormVisible
      treeKeyword: '',
      treeLoading: false,
      defaultTreeProps: {
        children: 'childs',
        label: 'name',
      },
      defaultExpandAll: false,
      treeData: [],
      defaultExpandIds: [],
      // 行id
      rowId: undefined,
      pageType: 'create',
      currentComp: 'TABLE',
      uploadFileProps: {
        templateLoading: false, // 模板加载状态
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      // 设备设施清单
      projectDataList: [],
      projectTableLoading: false,
      projectTotalCount: 0,
      projectSearchData: {},
      projectPageConfig: {
        SkipCount: 1,
        MaxResultCount: 999,
      },
      selectionProjectData: [],
      questionImportantList: [],
      showRelationModuleDialog: false, // 是否显示关联模块弹窗
      relationModuleRow: null, // 关联模块数据
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 128px)'
    },
    questionListMap() {
      return (val) => {
        return (
          _.find(this.questionList, (item) => {
            return item.code === val.examType
          })?.displayName || ''
        )
      }
    },
    buttonsProject() {
      return (val) => {
        return [
          {
            text: '移除',
            click: () => {
              return this.handleEvent(val, 'remove')
            },
            isShow: this.$hasAccess('remove'),
          },
          {
            text: '关联模块',
            click: () => {
              return this.handleEvent(val, 'relation')
            },
            isShow: true,
          },
        ]
      }
    },
  },
  watch: {
    addEvaluationProjectVisible(val) {
      if (!val) {
        this.currentTreeSelect = {}
        this.getProjectConfigTree()
        this.getProjectList()
      }
    },
  },
  created() {
    this.getProjectConfigTree()
    this.getProjectList()
  },
  methods: {
    cancelCopyProjectConfigForm() {
      this.copyProjectConfigFormVisible = false
      this.copyProjectConfigForm.name = ''
    },
    saveCopyProjectConfigForm() {
      this.$refs.copyProjectConfigFormRef.validate(async (valid) => {
        if (valid) {
          const [err, res] = await safetyEvaluationIndexApi.copy({
            body: {
              id: this.currentTreeSelect.id,
              name: this.copyProjectConfigForm.name,
            },
          })
          if (!err) {
            this.$message({
              message: '复制成功',
              type: 'success',
            })
            this.cancelCopyProjectConfigForm()
            this.getProjectConfigTree()
          }
        }
      })
    },
    saveSubProjectConfigForm() {
      this.$refs.addSubProjectConfigRef.validate(async (valid) => {
        if (valid) {
          this.addSubProjectConfigForm.chapter = this.addSubProjectConfigForm.chapter.toString()
          if (!this.addSubProjectConfigForm.id) {
            const [err, res] = await safetyEvaluationIndexApi.insert({
              body: {
                ...this.addSubProjectConfigForm,
                parentId: this.currentTreeSelect.id,
                chapter: `${this.addSubProjectConfigForm.upChapter}.${this.addSubProjectConfigForm.chapter}`,
              },
            })
            if (!err) {
              this.$message({
                message: '新增成功',
                type: 'success',
              })
              this.cancelSubProjectConfigForm()
              this.getProjectConfigTree()
            }
          } else {
            const [err, res] = await safetyEvaluationIndexApi.update(
              this.addSubProjectConfigForm.id,
              {
                body: {
                  ...this.addSubProjectConfigForm,
                  parentId: this.currentTreeSelect.parentId
                    ? this.currentTreeSelect.parentId
                    : this.currentTreeSelect.id,
                  chapter: `${this.addSubProjectConfigForm.upChapter}.${this.addSubProjectConfigForm.chapter}`,
                },
              }
            )
            if (!err) {
              this.$message({
                message: '修改成功',
                type: 'success',
              })
              this.cancelSubProjectConfigForm()
              this.getProjectConfigTree()
            }
          }
        }
      })
    },
    cancelSubProjectConfigForm() {
      this.addSubProjectConfigFormVisible = false
      this.addSubProjectConfigForm = {
        isContainsEvaluation: true,
      }
      this.$refs.addSubProjectConfigRef.resetFields()
    },
    cancelFirstProjectConfigForm() {
      this.addFirstProjectConfigFormVisible = false
      this.addFirstProjectConfigForm = {}
      this.$refs.addFirstProjectConfigRef.resetFields()
    },
    saveFirstProjectConfigForm() {
      this.$refs.addFirstProjectConfigRef.validate(async (valid) => {
        if (valid) {
          this.addFirstProjectConfigForm.chapter = this.addFirstProjectConfigForm.chapter.toString()
          if (!this.addFirstProjectConfigForm.id) {
            const [err, res] = await safetyEvaluationIndexApi.insert({
              body: this.addFirstProjectConfigForm,
            })
            if (!err) {
              this.$message({
                message: '修改成功',
                type: 'success',
              })
              this.cancelFirstProjectConfigForm()
              this.getProjectConfigTree()
            }
          } else {
            const [err, res] = await safetyEvaluationIndexApi.update(
              this.addFirstProjectConfigForm.id,
              {
                body: this.addFirstProjectConfigForm,
              }
            )
            if (!err) {
              this.$message({
                message: '新增成功',
                type: 'success',
              })
              this.cancelFirstProjectConfigForm()
              this.getProjectConfigTree()
            }
          }
        }
      })
    },
    searchTreeData() {
      this.$refs.tree.filter(this.treeKeyword)
    },
    handleTree(data, saveParentId = '') {
      return data.map((item) => {
        if (item.childs) {
          this.handleTree(item.childs, item.id)
        }
        if (!item.parentId) {
          item.saveParentId = item.id
        } else {
          item.saveParentId = saveParentId
        }
        return item
      })
    },
    async getProjectConfigTree() {
      const data = {
        keywords: this.treeKeyword, // 每页多少条
      }
      this.treeLoading = true
      const [err, res] = await safetyEvaluationIndexApi.getTreeList(data)
      if (!err) {
        this.treeData = this.handleTree(res)
      }
      this.treeLoading = false
    },
    operateTree(bool) {
      this.defaultExpandIds = this.$options.data().defaultExpandIds
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    async removeTreeData(e, type, data) {
      this.$confirm('是否确认删除目录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await safetyEvaluationIndexApi.callDelete(data.id)
        if (!err) {
          this.$message({
            message: '删除成功',
            type: 'success',
          })
        }
        this.getProjectConfigTree()
      })
    },
    async handleTreeData(e, type, data) {
      this.currentTreeSelect = data
      if (type === 'copy') {
        this.copyProjectConfigFormVisible = true
        return
      }
      if (type === 'createProjectConfig') {
        this.addFirstProjectConfigFormVisible = true
        this.addFirstProjectConfigFormTitle = '新增目录'
      }
      if (type === 'createChild') {
        this.showMenuTree = false
        this.addSubProjectConfigForm.upName = data.name
        this.addSubProjectConfigForm.upChapter = data.chapter
        this.addFirstProjectConfigFormTitle = '新增子目录'
        this.addSubProjectConfigFormVisible = true
        this.$nextTick(() => {
          this.showMenuTree = true
        })
      }
      if (type === 'edit') {
        this.addFirstProjectConfigFormVisible = true
        this.addFirstProjectConfigForm = JSON.parse(JSON.stringify(data))
        this.addFirstProjectConfigFormTitle = '编辑目录'
      }
      if (type === 'editChild') {
        this.showMenuTree = false
        this.addSubProjectConfigForm = JSON.parse(JSON.stringify(data))
        this.addSubProjectConfigForm.upName = data.name
        const chapterArr = data.chapter.split('.')
        const lastChapter = chapterArr[chapterArr.length - 1].length
        const upChapter = data.chapter.substring(0, data.chapter.length - lastChapter - 1)
        const chapter = chapterArr[chapterArr.length - 1]
        this.addSubProjectConfigForm.upChapter = upChapter
        this.addSubProjectConfigForm.chapter = chapter

        this.addSubProjectConfigFormTitle = '编辑子目录'
        // this.addFirstProjectConfigFormTitle = '编辑子目录'
        this.addSubProjectConfigFormVisible = true
        this.$nextTick(() => {
          this.showMenuTree = true
        })
      }
    },
    filterTreeNode(value, data) {
      if (!value) {
        return true
      }
      return data.name.indexOf(value) !== -1
    },
    handleDocNodeClick(e, node, data) {
      this.addFirstProjectConfigForm.index = node.level
      this.currentTreeSelect = node.data
      this.getProjectList()
    },
    // 节点展开
    nodeExpand(data) {
      this.currentTreeSelect = { ...data, parentId: '' }
    },
    // 节点关闭
    nodeCollapse(data) {},
    // 重置
    resetText() {
      this.projectDataList = []
      this.currentTreeSelect = {}
      this.projectSearchData = this.$options.data().projectSearchData
      this.handleSearch()
    },
    // 列表操作-事件 设备设施清单
    async handleEvent(row = null, operation) {
      let err = null
      let res = null
      switch (operation) {
        case 'create':
          if (!this.currentTreeSelect?.id) {
            this.$message({
              type: 'error',
              message: '请选择评价目录',
            })
            return
          }
          this.addEvaluationProjectVisible = true
          break
        case 'remove':
          this.$confirm('是否删除勾选的记录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            ;[err, res] = await safetyEvaluationIndexApi.unbindSafetyEvaluationIndex(
              row.safetyEvaluationIndexId
            )
            if (!err) {
              this.$message({
                showClose: true,
                message: '解绑成功',
                type: 'success',
              })
              this.getProjectList()
              this.getProjectConfigTree()
            }
          })
          break
        case 'relation':
          this.relationModuleRow = row
          this.showRelationModuleDialog = true
          break
        default:
          break
      }
    },
    // 弹窗初始化操作
    initDialog(operation) {
      this.checkComp(operation.toUpperCase())
      this.pageType = operation
    },
    handleSelectionProject(values) {
      this.selectionProjectData = values
    },
    // 搜索
    handleSearch() {
      this.projectPageConfig.SkipCount = 1
      this.getProjectList()
    },
    // 页码改变
    projectTableSizeChange(MaxResultCount) {
      this.projectPageConfig.MaxResultCount = MaxResultCount
      this.getProjectList()
    },
    // 页数改变
    projectTableCurrentChange(SkipCount) {
      this.projectPageConfig.SkipCount = SkipCount
      this.getProjectList()
    },
    // 设备设施列表
    async getProjectList() {
      this.selectionProjectData = []
      const projectSearchData = utils.deleteFormField(this.projectSearchData)
      const data = {
        maxResultCount: this.projectPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.projectPageConfig.SkipCount - 1) * this.projectPageConfig.MaxResultCount, // 跳过多少条
        safetyEvaluationIndexId: this.currentTreeSelect.id, // 目录id
        ...projectSearchData,
      }
      this.projectTableLoading = true
      const [err, res] = await safetyEvaluationIndexApi.getSafetyEvaluationIndexPageList(data)
      if (!err) {
        this.projectDataList = res.items
        this.projectTotalCount = res.totalCount
      }
      this.projectTableLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.hidden {
  display: none;
}

::v-deep .el-card__body {
  height: 100%;
}
.tree {
  height: calc(100% - 74px);
  ::v-deep .el-tree-node__content {
    height: 35px;
    .node-item {
      width: calc(100% - 24px);
      .custom-tree-node {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
  }
}
.two-row {
  ::v-deep .el-form-item__content {
    margin-right: 0px;
    display: flex;
    .el-input-number {
      margin-left: 20px;
      flex: 1;
    }
    .el-select {
      flex: 1;
      .el-input {
        width: 100%;
      }
    }
  }
}
::v-deep .el-table__body .el-table__row .cell {
  padding: 10px 0;
  height: 100px;
  overflow: scroll;
}
</style>
